import { schema } from "normalizr";
import { peopleTypes } from "../types";
import Resource from "./resource";
import { setPage } from "./pagination";

const peopleSchema = new schema.Entity("people");

export const setPeoplePage = page => setPage(page, "people");
export default new Resource("/people", peopleTypes, peopleSchema);
